import Log from '@/Utils/Log';

export const pushFilterFromEnum = (filters, obj, filterSearchType, getFilterGroupDisplayName = () => ({})) => (value) => {
    filters.push({
        key: obj[value].name,
        label: obj[value].displayName,
        group: getFilterGroupDisplayName(filterSearchType),
        filterSearchType,
        value,
    });
};

export function convertArrayParamsToCommaSeparatedList(object) {
    return Object.entries(object).reduce((acc, [key, val]) =>
        ({ ...acc, [key]: Array.isArray(val) ? val.join(',') : val }), {});
}

export function updateSearchParamsWithLocation(searchResultQuery, data = null) {
    const search = new URLSearchParams(searchResultQuery).toString();
    const location = new URL(window.location);
    location.search = search;
    window.history.replaceState(data, null, location.toString());
}

export async function updateSearchParamsWithRouter(searchResultQuery, routerInstance) {
    if (!routerInstance) {
        return;
    }

    const searchParams = new URLSearchParams(searchResultQuery);
    const newQueryObject = Object.fromEntries(searchParams.entries());

    const currentRoute = routerInstance.currentRoute;
    const path = typeof currentRoute.value?.path === 'string'
        ? currentRoute.value.path
        : currentRoute.path;

    const currentQuery = currentRoute.value?.query || currentRoute.query || {};

    const queriesAreEqual = areQueriesEqual(currentQuery, newQueryObject);

    if (queriesAreEqual) {
        return;
    }

    try {
        await routerInstance.replace({
            path,
            query: newQueryObject,
        });
    }
    catch (error) {
        Log.warn('Failed to update search params with router', error);
    }
}

function areQueriesEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}